import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as PackageInventoryStore from '../../../redux/packageInventory';
import { CheckboxFilterGroup } from '../../generic/Filter';
import type { AnyFilter, Visibility } from '../../../../shared/organizationPackages';
import type { FilterOption } from '../../generic/Filter/CheckboxFilterGroup';

const FILTER_OPTIONS: FilterOption[] = [
  { key: 'public', label: 'Public' },
  { key: 'private', label: 'Private' },
];

type Props = {
  setFilters: (filters: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersProject has filters related to searching
 * by project name, import method, visibility, or project label.
 */
const PackageInventoryFiltersProjectVisibility: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const visibility = useSelector(PackageInventoryStore.selectors.getFiltersProjectVisibility);

  const onSelect = (key: Visibility, isChecked: boolean) => {
    if (isChecked) {
      setFilters({ visibility: [...visibility, key] });
    } else {
      setFilters({ visibility: visibility.filter(vis => vis !== key) });
    }
  };

  return (
    <CheckboxFilterGroup
      title="Visibility in FOSSA"
      options={FILTER_OPTIONS}
      selectedOptions={visibility}
      onSelect={onSelect}
      testId="package-inventory-filters--visibility"
    />
  );
};

export default PackageInventoryFiltersProjectVisibility;
